export function createRoutes() {
  return [
    {
      path: 'videos',
      component: () => import(/* webpackChunkName: "VideoChrome" */ './VideoChrome.vue'),
      children: [
        {
          path: '/',
          name: 'videoList',
          component: () => import(/* webpackChunkName: "VideoList" */ './VideoList.vue'),
        },
        {
          path: 'upload',
          components: {
            default: () => import(/* webpackChunkName: "VideoList" */ './VideoList.vue'),
            dialog: () => import(/* webpackChunkName: "VideoUploaderModal" */ './VideoUploaderModal.vue'),
          },
        },
        {
          path: 'import',
          components: {
            default: () => import(/* webpackChunkName: "VideoList" */ './VideoList.vue'),
            dialog: () => import(/* webpackChunkName: "VideoEditChrome" */ './ImportVideoModal.vue'),
          },
        },
        {
          path: ':videoId',
          component: () => import(/* webpackChunkName: "VideoEditChrome" */ '@/video/VideoEdit.vue'),
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
